export enum ChartLabels {
    NO_VALUE = '___dku_no_value___',
    SUBTOTAL_BIN_LABEL = '___dku_total_value___',
    NO_RECORDS = 'No records'
}
